module.exports = __webpack_public_path__ + "img/left.a6b24d3f.png";